import reduceBy from "./reduceBy.js";
var indexBy = reduceBy(function (acc, elem) {
    return elem;
}, null);
export default indexBy;
